<template>
  <!-- Authenticated: internal LMS layout (sidebar + header) -->
  <div v-if="isLoggedIn" class="flex h-screen overflow-hidden bg-base text-ink">
    <Sidebar />
    <div class="flex-1 flex flex-col overflow-hidden">
      <Header />
      <main class="flex-1 overflow-y-auto">
        <div class="px-4 sm:px-6 lg:px-8 py-6">
          <slot />
        </div>
      </main>
    </div>
  </div>

  <!-- Guest: public marketing layout (top navbar + footer) -->
  <div v-else class="min-h-screen flex flex-col bg-base text-ink">
    <PublicNavbar />
    <main :class="['flex-1', heroMode ? '' : 'pt-16 sm:pt-[72px]']">
      <div v-if="heroMode">
        <slot />
      </div>
      <div v-else class="container-app py-8 sm:py-10">
        <slot />
      </div>
    </main>
    <SiteFooter />
  </div>
</template>

<script>
/* eslint-disable vue/multi-word-component-names */
import Sidebar from "@/components/ui-components/Sidebar.vue";
import Header from "@/components/ui-components/Header.vue";
import PublicNavbar from "@/components/ui-components/PublicNavbar.vue";
import SiteFooter from "@/components/ui-components/SiteFooter.vue";
import { isAuthenticated } from "@/utils/auth";

export default {
  name: "AppShell",
  components: { Sidebar, Header, PublicNavbar, SiteFooter },
  props: {
    // When true, guest content renders full-bleed (landing hero handles its own spacing)
    heroMode: { type: Boolean, default: false },
  },
  computed: {
    isLoggedIn() {
      return isAuthenticated();
    },
  },
};
</script>
